import { __decorate } from "tslib";
import { Component, Vue } from "../../../../vue";
import { FORM_METHOD_TYPES } from "../../../../core/stateCommon/consts";
import { IMethodEditorState } from "../../MethodEditorState";
import InitForm from "./InitForm";
import RequestForm from "./RequestForm";
let FormEditor = class FormEditor extends Vue {
  constructor() {
    // _tsx:DeclareProps<Pick<FormEditor,''>>
    super(...arguments);
    this.height = 0;
  }
  get formInfo() {
    var _this$state$method;
    return (_this$state$method = this.state.method) === null || _this$state$method === void 0 ? void 0 : _this$state$method.formInfo;
  }
  get isInit() {
    var _this$formInfo;
    return ((_this$formInfo = this.formInfo) === null || _this$formInfo === void 0 ? void 0 : _this$formInfo.type) === FORM_METHOD_TYPES.init;
  }
  renderContent() {
    const h = this.$createElement;
    if (!this.formInfo) return null;
    return this.isInit ? h(InitForm, {
      "attrs": {
        "formInfo": this.formInfo
      }
    }) : h(RequestForm, {
      "attrs": {
        "formInfo": this.formInfo
      }
    });
  }
  render() {
    const h = arguments[0];
    return h("div", [this.renderContent()]);
  }
};
__decorate([IMethodEditorState], FormEditor.prototype, "state", void 0);
FormEditor = __decorate([Component({
  name: 'FormEditor'
})], FormEditor);
export default FormEditor;
//# sourceMappingURL=index.js.map
